import { ProductCard } from "../ProductCard";
import { ProductListLayout } from "../../types/types";
import styles from "./Bundle.module.scss";

export const Bundle: ProductListLayout = ({ config, products, heading }) => {
  const [firstProduct, ...otherProducts] = products;

  if (!firstProduct) {
    return null;
  }

  return (
    <div data-product-list-layout="Bundle">
      {heading?.main && <h2>{heading?.main}</h2>}
      {heading?.subHeading && <p>{heading?.subHeading}</p>}
      <div className={styles.carousel}>
        <div className={styles.cardsWrapper}>
          <h3 className={styles.cardsWrapperTitle}>This item</h3>
          <div className={styles.cardWrapper}>
            <ProductCard
              key={
                firstProduct.advertising
                  ? `${firstProduct.aliases.pimProductId}-sponsored`
                  : firstProduct.aliases.pimProductId
              }
              product={firstProduct}
              config={config}
              index={0}
            />
          </div>
        </div>
        <div className={styles.joiner}>+</div>
        <div className={styles.cardsWrapper}>
          <h3 className={styles.cardsWrapperTitle}>Bought with</h3>
          <div className={styles.otherProductsWrapper}>
            {otherProducts.map((product, ind) => (
              <>
                <div className={styles.cardWrapper}>
                  <ProductCard
                    key={
                      product.advertising
                        ? `${product.aliases.pimProductId}-sponsored`
                        : product.aliases.pimProductId
                    }
                    product={product}
                    config={config}
                    index={ind + 1}
                  />
                </div>
                {ind + 1 < otherProducts.length && (
                  <div className={styles.joiner}>+</div>
                )}
              </>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
